export const goToBackPageTransformer = (count: number, url: string) => {
    const urlEdited  = (url.split('/'))
    let newUrl = "/" +(urlEdited.slice(1, urlEdited.length - count)).join("/")
    return newUrl;
    
  }